module.exports = __webpack_public_path__ + "static/media/DigitAlb_Albania.8f7d254e.png";